<skl-dialog-content-ins>
	<skl-dialog-header-ins
		[title]="'ui.filtering-data.sort-dialog.header' | translate"
		(onClose)="onCancel()">
	</skl-dialog-header-ins>
	<ins-content>
        <div class="wrapper">
            @for (item of data.items; track item) {
                <div
                    class='item'
                    (click)="select(item.value)">
                    <div class="label" [ngClass]="{'text--bold': isCurrentValue(item)}">
                        @if (isCurrentValue(item)) {
                            <span class="order-icon">
                                <skl-sort-icon [sortDirection]="data.direction"></skl-sort-icon>
                            </span>
                        }
                        <span [ngClass]="{'no-icon': !isCurrentValue(item)}">{{item.label}}</span>
                    </div>
                    <div class="icon-wrapper">
                        @if (isCurrentValue(item)) {
                            <skl-icon
                                color="accent"
                                name="check">
                            </skl-icon>
                        }
                    </div>
                </div>
            }
        </div>
	</ins-content>

	<ins-footer class="dialog__buttons">
		<skl-button
			typeName="accent"
			(click)="onCancel()">
			{{ 'ui.filtering-data.sort-dialog.buttons.confirm' | translate }}
		</skl-button>
	</ins-footer>
</skl-dialog-content-ins>